import { ReactNode } from 'react'
import { Dialog } from 'primereact/dialog';

type DialogBoxProps = {
    open: boolean;
    close: () => void;
    children: ReactNode;
    className?: string,
    headerName?: string
}
const DialogBox = (props: DialogBoxProps) => {
    return (
        <Dialog position={'top'} header={<h1
            className='font-bold text-gray-700 text-[14px] dark:!text-gray-500'>{props.headerName}</h1>}
            headerClassName='dark:!bg-sky-950 !bg-white !pb-1 !pt-4 dark:text-gray-500'
            contentClassName='dark:!bg-sky-950 !bg-white'
            maskClassName='backdrop-blur-lg bg-opacity-75'
            className={`dark:bg-sky-950 sm:w-3/4 w-3/4 md:w-1/2 lg:w-1/2 xl:w-1/2 ml-[5.5rem] top-0 ${props.className}`} draggable={false} visible={props.open} onHide={props.close}>
            {props.children}
        </Dialog>
    )
}

export default DialogBox